import(/* webpackMode: "eager" */ "C:\\Users\\Serhat Altun\\Downloads\\ser\\src\\app\\page.tsx");
